var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import useMultiTokenData from './useMultiTokenData';
import { nativeTokens } from './useTokenSearch';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
export default function useGetNativeTokenData() {
    var _a = useState([]), nativeTokensData = _a[0], setNativeTokensData = _a[1];
    var _b = useMultiTokenData({
        tokens: nativeTokens.map(function (x) { return x.wrappedAddress + ':' + x.network; }),
        minMarketCap: 0,
    }), nativeTokensPreData = _b.data, nativeTokensDataLoading = _b.isLoading;
    useEffect(function () {
        if ((nativeTokensPreData === null || nativeTokensPreData === void 0 ? void 0 : nativeTokensPreData.length) > 0) {
            var data = nativeTokensPreData.map(function (x) {
                var nativeTokenToFind = nativeTokens.find(function (y) {
                    var _a, _b, _c;
                    return ((_a = y.wrappedAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = x === null || x === void 0 ? void 0 : x.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()) &&
                        y.network === x.token.networkId;
                });
                return __assign(__assign({}, x), { token: __assign(__assign({}, x.token), { name: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.tokenName, symbol: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.token, address: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.tokenAddress, imageSmallUrl: getNetworkLogo(nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.network), imageThumbUrl: getNetworkLogo(nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.network) }) });
            });
            setNativeTokensData(data);
        }
    }, [nativeTokensPreData]);
    return { nativeTokensData: nativeTokensData, nativeTokensDataLoading: nativeTokensDataLoading };
}
